import { render, staticRenderFns } from "./resourceApplyAppoint.vue?vue&type=template&id=65143f2f&scoped=true&"
import script from "./resourceApplyAppoint.vue?vue&type=script&lang=js&"
export * from "./resourceApplyAppoint.vue?vue&type=script&lang=js&"
import style0 from "./resourceApplyAppoint.vue?vue&type=style&index=0&id=65143f2f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65143f2f",
  null
  
)

export default component.exports